export default function getShortMonthName(name){
    return name.substr(0, 1);
}